var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"change-company mb-0 mr-2",on:{"click":function($event){return _vm.clickBadge()}}},[_vm._v(" "+_vm._s(_vm.nameCompany)+" ")]),(_vm.canChangeCompanies)?_c('modal-companies'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }